export function filesFromClipboardData(data: DataTransfer | null | undefined): File[] {
  if (!data) return [];
  const fromList = Array.from(data.files);
  if (fromList.length) return fromList;
  const fromItems: File[] = [];
  for (const item of Array.from(data.items)) {
    if (item.kind !== 'file' || !item.type.startsWith('image/')) continue;
    const file = item.getAsFile();
    if (file) fromItems.push(file);
  }
  return fromItems;
}
